export default __webpack_public_path__ + "static/media/logout-outline-16px.75ead541.svg";